import React from "react";
import PropTypes from "prop-types";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import VcCompare from "../../../components/vcCompare/vcCompare";

const Dropdown = ({
  vcCompare = false,
  options = [],
  value = [],
  onChange = () => {},
  title,
  classNames = ""
}) => {
  return (
    <>
      {vcCompare && (
        <div className="vc-compare">
          <VcCompare />
        </div>
      )}
      <div className={"select-box-no-width " + classNames}>
        {title && <p>{title}</p>}
        <MultiSelectDropdown
          options={options}
          selectedFilters={value}
          includeFilter={false}
          numberDisplayed={0}
          onSelectChange={onChange}
        />
      </div>
    </>
  );
};

Dropdown.propTypes = {
  vcCompare: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.any),
  values: PropTypes.any,
  onChange: PropTypes.func,
  title: PropTypes.string,
  classNames: PropTypes.string
};

export default Dropdown;
